import { Injectable } from '@angular/core';
import { TrackingConsentStatus } from './tracking-consent-banner/tracking-consent.interfaces';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  getTrackingConsent(): TrackingConsentStatus | null {
    return localStorage.getItem('tracking-consent') as TrackingConsentStatus;
  }

  setTrackingConsent(status: TrackingConsentStatus) {
    localStorage.setItem('tracking-consent', status);
  }
}
